module.exports = __webpack_public_path__ + "static/media/pravo-povlekuvanje-karposh.ae807f18.docx";